import { styled } from "goober";
import type { ConnectorWithOAuth } from "../../../shared/connectors/getTargetValue";
import type { CopyableItem } from "../../../shared/connectors/types";
import { Box } from "../Box";
import { Icon } from "../Icon";
import { Text } from "../Text";
import { writeToClipboard } from "../../lib/writeToClipboard";
import { useRenderWithPlaceholders } from "./renderWithPlaceholders";

const Value = styled("div")`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  border: 0.5px solid var(--border-alpha);
  color: var(--text);
  user-select: all;
  white-space: nowrap;
  background: var(--alpha2);
  color: var(--text-primary);
  position: relative;
`;

const CopyButton = styled("button")`
  border: 0;
  cursor: pointer;
  background: none;
  font-size: 12px;
  cursor: pointer;
  position: absolute;
  right: 4px;
`;

export function CopyableFieldItem({
  item,
  app,
}: {
  item: CopyableItem;
  app: ConnectorWithOAuth;
}) {
  const renderWithPlaceholders = useRenderWithPlaceholders();
  const value = renderWithPlaceholders(item.value, {
    CONNECTED_APP_ID: app.id,
  });

  return (
    <div>
      <Box horizontal={8} vertical={10}>
        <Text variant="text-small-md" color="var(--text-primary)">
          {item.label}
        </Text>
      </Box>
      <Value onClick={() => void writeToClipboard(value)}>
        <span style={{ opacity: 0.5 }}>
          <Text variant="text-regular">{value}</Text>
        </span>
        <CopyButton type="button">
          <Icon name="copy" size={12} />
        </CopyButton>
      </Value>
    </div>
  );
}
